import { z } from 'zod'
import type { PaginatedResponse } from './common'

export const unlockPolicySchema = z.enum(['all_unlocked', 'day_based'])
export type UnlockPolicy = z.infer<typeof unlockPolicySchema>

export const membershipTierSchema = z.enum(['free', 'premium'])
export type MembershipTier = z.infer<typeof membershipTierSchema>

const baseCourseSchema = z.object({
  title_en: z.string().min(3).max(200),
  title_hi: z.string().min(3).max(200),
  description_en: z.string().max(10000).optional(),
  description_hi: z.string().max(10000).optional(),
  price_paise: z.number().int().nonnegative().optional(),
  validity_days: z.number().int().positive(),
  unlock_policy: unlockPolicySchema.default('all_unlocked'),
  is_published: z.boolean().default(false),
  thumbnail_url: z.string().url().optional(),
  assignment_url: z.string().url().optional(),
  tier_required: membershipTierSchema.default('free'),
})

export const createCourseSchema = baseCourseSchema
export const updateCourseSchema = baseCourseSchema.partial()

export type CreateCourseInput = z.infer<typeof createCourseSchema>
export type UpdateCourseInput = z.infer<typeof updateCourseSchema>

export type CourseResponse = {
  id: string
  legacy_id?: string | null
  title_en: string
  title_hi: string
  description_en?: string | null
  description_hi?: string | null
  price_paise?: number
  validity_days: number
  unlock_policy: UnlockPolicy
  is_published: boolean
  thumbnail_url?: string | null
  assignment_url?: string | null
  has_assignment?: boolean
  tier_required: MembershipTier
  created_at: string
  updated_at: string
}

export type PublicCourseResponse = {
  id: string
  legacy_id?: string | null
  title: string
  description?: string | null
  price_paise: number
  validity_days: number
  unlock_policy: UnlockPolicy
  is_published: boolean
  thumbnail_url?: string | null
  assignment_url?: string | null
  has_assignment?: boolean
  tier_required: MembershipTier
}

export type CourseSortBy =
  | 'created_at'
  | 'title_en'
  | 'title_hi'
  | 'price_paise'

export type PaginatedCourseResponse = PaginatedResponse<CourseResponse>
export type PaginatedPublicCourseResponse =
  PaginatedResponse<PublicCourseResponse>
